export const ModuleEnum = {
  Users: 1,
  Profiles: 2,
  Menus: 3,
  Modules: 4,
  Accounts: 5,
  Locations: 6,
  Routes: 7,
  Markets: 8,
  InstantQuotes: 9,
  Quotation: 10,
  Contracts: 11,
  Carriers: 12,
  Shippers: 13,
  Tenders: 14,
}

export const ModuleActionEnum = {
  Create: 1,
  Update: 2,
  Delete: 3,
  Read: 4,
  List: 5,
  Admin: 6,
}

export const ModuleEnumReverse = Object.fromEntries(
  Object.entries(ModuleEnum).map(([k, v]) => [v, k])
)

export const ModuleActionEnumReverse = Object.fromEntries(
  Object.entries(ModuleActionEnum).map(([k, v]) => [v, k])
)